import { useEffect, useState, useRef, useMemo } from 'react';
import Box from '@mui/material/Box';
import { Formik, Form, Field } from 'formik';
import { constants } from '../../../../constants';
// import styles from "./TicketStyle.module.css";
import { styled, lighten, darken } from '@mui/system';
import { getDataFromS3 } from 'app/main/CompanyList/companyFunctions';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import Autocomplete from '@mui/material/Autocomplete';
import { Typography, TextField, Switch, Dialog, Button,Divider,IconButton, Select, Icon, DialogContent, Tooltip, Table, TableContainer, TableHead, TableCell,
    TableRow,TableBody,
    DialogActions,
    DialogTitle,
    DialogContentText,
    MenuItem
} from '@mui/material';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useDispatch } from 'react-redux';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import client from 'client';
import { connect } from 'react-redux';
import FuseLoading from '@fuse/core/FuseLoading/FuseLoading';
const token = localStorage.token;
const comp_acct = localStorage.comp_acct;
import DeleteIcon from '@mui/icons-material/Delete';
import ButtonLog from 'app/main/ButtonLog';
import { FileUploader } from 'react-drag-drop-files'
import { v4 as uuid } from 'uuid'
import './ticket_animation.css'
import WestIcon from '@mui/icons-material/West';
import EastIcon from '@mui/icons-material/East';
import ViewListIcon from '@mui/icons-material/ViewList';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import JobTicketAction from 'app/stores/loadz/redux/JobsReport/actions';
import AddIcon from '@mui/icons-material/Add';
import CircularLoader from 'app/main/loadz/components/CircularLoader';
import { isManualTicketDateMissing, isManualTicketTimeMissing, syncTicketTimeFieldsFromDom, ticketTruckDriverCompanyMismatch } from '../buildManualTicketTime';
import { suggestedTicketQty } from '../suggestedTicketQty';
import TicketCreateSummary from './TicketCreateSummary';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useTranslation} from 'react-i18next';

const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-8px',
  padding: '4px 10px',
  color: '#000000',
  fontWeight: 'bold',
  backgroundColor:
    theme.palette.mode === 'light'
      ? lighten(theme.palette.primary.light, 0.85)
      : darken(theme.palette.primary.main, 0.8),
}));

const GroupItems = styled('ul')({
  padding: 0,
});

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  // maxHeight: "770px",
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 4,
  p: 0,
  over: 'scroll',
};

const wait_style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  // maxHeight: "770px",
  bgcolor: 'black',
  boxShadow: 24,
  borderRadius: 4,
  p: 0,
  border: 80,
  borderStyle: 'dashed',
  borderColor: 'red',
  borderWidth: 20,
};

const boderanimate = {
  padding: '0 30px 10px',
  paddingBottom: '0',
  // marginTop: "20px",
};
const cursorp = {
  cursor: 'pointer',
};
const printpdf = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'end',
  position: 'absolute',
  right: '10px',
  top: '10px',
  alignItems: 'center',
  width: 'auto',
  padding: '10px',
  background: 'red',
  borderRadius: '10px',
  paddingTop: '7px',
};
const regex = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/;
const time_regex = RegExp('[0-9]');
const DEFAULT_SCALE_IMAGE_UPLOAD_LIMIT = 10

const TicketScaleImageUploader = ({open,setOpen, handleAddEditScaleImage,setFieldId}) => {
  const {t} = useTranslation('navigation');
  const fileTypes = ['JPEG', 'PNG', 'JPG']

  const onChange = async (file) => {
    let url = URL.createObjectURL(file)
    handleAddEditScaleImage(file)
    setOpen(false)
  } 

  return (
  <Dialog
    open={open}
    onClose={() => {     
      setOpen(false)
      setFieldId(null)
    }}
  >
    <FileUploader
      children={
        <div className="flex flex-col p-8">
          <Box
            sx={{
              border: '5px dashed lightblue',
              borderRadius: 5,
              padding:2,
              width:'500px'
            }}
          >
            <div className="flex flex-col gap-y-16 justify-center align-center items-center pb-32">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="172"
                height="200"
                viewBox="0 0 172 149"
                fill="none"
              >
                <g clip-path="url(#clip0_141_2095)">
                  <path
                    d="M87.7472 54.6136C87.5441 54.3419 87.2804 54.1213 86.9771 53.9693C86.6738 53.8173 86.3392 53.7382 86 53.7382C85.6607 53.7382 85.3261 53.8173 85.0228 53.9693C84.7195 54.1213 84.4559 54.3419 84.2528 54.6136L56.3712 91.7765C56.1269 92.1003 55.9778 92.4858 55.9406 92.8897C55.9034 93.2936 55.9796 93.6998 56.1607 94.0628C56.3418 94.4257 56.6206 94.731 56.9657 94.9442C57.3109 95.1575 57.7086 95.2702 58.1143 95.2699H73.0645C73.6437 95.2699 74.1992 95.4993 74.6095 95.908C75.0198 96.3166 75.2514 96.8712 75.2535 97.4502V146.82C75.2525 147.107 75.3081 147.391 75.4172 147.657C75.5263 147.922 75.6868 148.163 75.8894 148.367C76.0921 148.57 76.3328 148.731 76.598 148.841C76.8631 148.951 77.1474 149.008 77.4345 149.008H94.5655C94.8526 149.008 95.1369 148.951 95.402 148.841C95.6671 148.731 95.9079 148.57 96.1105 148.367C96.3132 148.163 96.4736 147.922 96.5828 147.657C96.6919 147.391 96.7475 147.107 96.7464 146.82V97.4502C96.7486 96.8712 96.9802 96.3166 97.3904 95.908C97.8007 95.4993 98.3563 95.2699 98.9355 95.2699H113.886C114.291 95.2702 114.689 95.1575 115.034 94.9442C115.379 94.731 115.658 94.4257 115.839 94.0628C116.02 93.6998 116.097 93.2936 116.059 92.8897C116.022 92.4858 115.873 92.1003 115.629 91.7765L87.7472 54.6136Z"
                    fill="#BDBBBB"
                  />
                  <path
                    d="M154.188 51.412C153.089 50.6284 152.157 49.6333 151.447 48.4851C150.737 47.3369 150.263 46.0586 150.053 44.7251C148.278 32.8346 138.703 0 99.6814 0C79.0884 0 65.403 16.9482 62.5249 20.8388C62.1382 21.3625 61.6008 21.7556 60.9845 21.9654C60.4635 22.1457 59.904 22.1849 59.363 22.0789C54.612 21.1468 29.7545 13.3819 24.2009 43.2662C23.5359 46.5425 21.6452 49.4415 18.9148 51.3715C8.07509 59.2255 -0.00805664 71.8374 -0.00805664 85.9487C0.025205 96.2777 3.76391 106.252 10.5287 114.059C17.2934 121.866 26.6353 126.988 36.8566 128.494C38.2661 128.709 39.7033 128.355 40.852 127.511C42.0007 126.666 42.7668 125.4 42.9818 123.991C43.1968 122.582 42.8431 121.145 41.9985 119.997C41.1539 118.848 39.8876 118.082 38.4781 117.867C31.8555 116.94 25.6886 113.965 20.8401 109.361C15.9916 104.756 12.704 98.7518 11.4372 92.1873C10.1704 85.6227 10.9877 78.8265 13.7749 72.7493C16.5621 66.672 21.1797 61.6177 26.9817 58.2934C28.6711 57.3171 30.1297 55.9875 31.2575 54.3956C32.3853 52.8036 33.1558 50.9868 33.5163 49.0696C38.1538 23.3757 56.5416 33.5236 61.5276 36.8143C61.9113 37.0649 62.3422 37.2345 62.7937 37.3127C63.2453 37.3909 63.7081 37.376 64.1537 37.269C64.5994 37.162 65.0184 36.9651 65.3852 36.6904C65.752 36.4157 66.0588 36.069 66.2868 35.6715L69.6513 29.8032C76.5022 17.9046 88.6877 9.53995 102.122 10.7882C135.411 13.779 139.724 38.3462 139.935 49.5964C139.96 51.3522 140.437 53.0721 141.32 54.5898C142.203 56.1076 143.463 57.372 144.978 58.261V58.261C150.809 61.5727 155.454 66.6282 158.262 72.7166C161.069 78.8049 161.897 85.6199 160.629 92.2032C159.361 98.7864 156.061 104.807 151.193 109.418C146.325 114.028 140.133 116.998 133.49 117.908C132.08 118.123 130.814 118.889 129.969 120.037C129.125 121.186 128.771 122.622 128.986 124.032C129.201 125.441 129.967 126.707 131.116 127.551C132.264 128.395 133.702 128.749 135.111 128.534C143.577 127.349 151.494 123.657 157.842 117.933C164.19 112.21 168.678 104.717 170.728 96.4198C172.778 88.1231 172.295 79.4027 169.343 71.3824C166.391 63.3621 161.104 56.4094 154.164 51.4201L154.188 51.412Z"
                    fill="#BDBBBB"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_141_2095">
                    <rect
                      width="172"
                      height="149"
                      fill="white"
                    />
                  </clipPath>
                </defs>
              </svg>
              &nbsp;
              <Typography className="text-18 font-bold">{t('DRAG_AND_DROP_FILES_HERE')}</Typography>
              <Typography className="text-14" color={'gray'}>{t('OR')}</Typography>
              <div className='flex w-3/5 justify-center align-center items-center'
              style={{border: '1px solid gray',padding:6, cursor:'pointer' }}
              >
              <Typography className="text-16 font-bold" color={'blue'}>{t('CLICK_HERE_TO_UPLOAD')}</Typography>
              </div>
              <div className="flex flex-col justify-center align-center items-center" style={{color:'gray'}}>
                <Typography className="text-14">{t('THESE_ARE_THE_ALLOWED_IMAGE_FORMAT')}:</Typography>
                <div>{fileTypes.join(", ")}</div>
              </div>
            </div>
          </Box>
        </div>
      }
      handleChange={onChange}
      name="file"
      types={fileTypes}
    />
  </Dialog>
  )
}

const CreateMultiTicketTable = ({
  handleclose,
  open,
  user,
  data,
  job_id,
  getAllTicketJobs,
  ticketStatus,
  inputFields,setInputFields,
  multiTicketView, setMultiTicketView,
  ticketSummary,setTicketSummary,
  defaultInputFields,
  jobbilling,
}) => {
  const {t} = useTranslation('navigation');
  const formikRef = useRef();
  const GET_PRE_SIGNED_URL = '/aws/pre-signed-url'
  const dispatch = useDispatch();
  const routeParams = useParams();
  const { id } = routeParams;
  const [JsonGetById, setJsonGetById] = useState(0);

  const [drivers, setdrivers] = useState([]);
  const [trucks, setTrucks] = useState([]);

  const [logo, setLogo] = useState('');
  const [errors, setErrors] = useState({});
  const [checked, setChecked] = useState(false);

  const [isSub, setIsSub] = useState(false);
  const [subId, setSubId] = useState(null);
  const [subName, setSubName] = useState(null);
  const [compLocation, setCompLocation] = useState('');
  const [subs, setSubs] = useState([]);
  const [owner_op, setOwner_Op] = useState([]);

  const [loading, setLoading] = useState(false);
  const [driverLoading, setDriverLoading] = useState(false);
  const [truckLoading, setTruckLoading] = useState(false);
  const [scaleTicketImageUploadLimit, setScaleTicketImageUploadLimit] = useState(null)
  const [currentLocation, setCurrentLocation] = useState()
  
  const getCurrentLatLong = () => {
    try {
    
      if (navigator.geolocation) {
        // If geolocation is supported, get the current position
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setCurrentLocation({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            })
          },
          (error) => {
            // Error callback - if something goes wrong
            console.error('Error occurred while retrieving geolocation:', error);
          }
        );
      } else {
        console.log('Geolocation is not supported by this browser.');
      }
    } catch (error) {
      console.log('Geolocation is not supported by this browser.' + error);
    }
  }

  const getJobInfo = async () => {

    const subjob = await client.get(`/jobs/ticket/${job_id ? job_id : id}`);
    console.log('subjob1::', subjob);
    setJsonGetById(subjob.data[0]);

  };


  const getCompanyDetail = async () => {
    try {
      if (!user?.company?.compacctnum) return

      const result = await client.post('/company/compacct', {id: user?.company?.compacctnum})
      if (result?.data?.scale_ticket_image_length) {
        setScaleTicketImageUploadLimit(result?.data?.scale_ticket_image_length)
      }

    } catch (error) {
      console.log(error)
    }
  }


  useEffect(async () => {
    if (open) {
      setTruckLoading(true);
      setDriverLoading(true);
      getdrivers();
      getTurcks();
      setLoading(true);
      await getJobInfo();
      await getCompanyDetail()

      /* if (isSub) {
        await getsubs();
        if (subId) {
          let key = subId.logo;
          console.log(subId);
          let resp = await getS3Location(key);
          console.log('key::', key);

          // setLogo(resp?.data?.data?.fileLocation);
          setLogo(key);
        }
      } */

    let key = data ? data.logo : user?.company?.logo;
    if (key.includes('http')) {
        setLogo(key);
    } else {
        setLogo(`${constants.URLLOCAL}/aws/signed?image=${key}`);
    }
    
    setLoading(false);

    getCurrentLatLong()
      
    }
  }, [open]);

  const onClose = () => {
    setErrors({});
    setChecked(false);
    setIsSub(false);
    setSubId(null);
    setScaleImage([]);
    setInputFields([{...defaultInputFields}])
    setFieldId(null)
    handleclose();
    setTicketSummary(null)
  };

  const getTickets = async() => {
    await getAllTicketJobs(
      {
        page: 1,
        data: {
          id: job_id ? job_id : id,
          estatus: ticketStatus,
          compacctnum: data ? data?.compacctnum : user.company.compacctnum,
        },
      },
      (e) => {
        console.log(e);
      }
    );
  }

  const [scaleImage, setScaleImage] = useState([]);
  const [openScaleImageUploader, setOpenScaleImageUploader] = useState(false);


  const allowToUploadScaleTicketImage = useMemo(() => {
    const limit = scaleTicketImageUploadLimit ?? DEFAULT_SCALE_IMAGE_UPLOAD_LIMIT
    return scaleImage.length < limit 
  }, [scaleTicketImageUploadLimit, DEFAULT_SCALE_IMAGE_UPLOAD_LIMIT, scaleImage])


  const _showMessage = (msg) => {
    dispatch(
      showMessage({
        message: (<>
          <Typography>{msg}</Typography>
        </>),//text or html
        autoHideDuration: 6000,//ms

        anchorOrigin: {
          vertical: 'top',//top bottom
          horizontal: 'right'//left center right
        },
        variant: "error" //success error info warning null
      }))
  }
  const [submitLoading, setSubmitLoading] = useState(false);
  const [openShiftConfirm, setOpenShiftConfirm] = useState(false);

  const [openTicketSummary, setOpenTicketSummary] = useState(false)

  const handleSummaryClose = async() => {
    if(ticketSummary)
    {
      //all successful tickets
      if(ticketSummary?.succ?.length >= 1 && ticketSummary?.err?.length <= 0)
      {
        onClose()
        setOpenTicketSummary(false)
        getTickets()
        
      } 
      //all errors
      else if(ticketSummary?.err?.length >= 1 && ticketSummary?.succ?.length <= 0)
      {
        setOpenTicketSummary(false)
      }
      //mix of both
      else if(ticketSummary?.err?.length >= 1 && ticketSummary?.succ?.length >= 1)
      {
        //remove successful tickets from inputFields
        //do nothing else, close summary modal
        //make summary open modal button appear if only errors exist in the ticketSummary at the top of the page
        const new_inputFields = [...inputFields]

        for(const i of ticketSummary?.succ)
        {
          new_inputFields.splice(i.idx, 1)          
        }

        setTicketSummary({err:ticketSummary?.err,succ:[]})
        setInputFields(new_inputFields)
        setOpenTicketSummary(false)


      }
      else
      {
        onClose()
        setOpenTicketSummary(false)
        getTickets()
      }

    }
    
   
  }

  const submitManualCreateTicket = async (options = {}) => {
    //console.log('DATE::', values.date);
    //console.log('TIME::', moment(values.date+'T'+values.time).format());

    const normalizedInputFields = syncTicketTimeFieldsFromDom(inputFields).map((field) => ({
      ...field,
      wait_duration: `${field.wait_durationhr}:${field.wait_durationmin}`,
      tk_duration: `${field.tk_durationhr}:${field.tk_durationmin}`,
    }));

    const multiPayload = await Promise.all(normalizedInputFields.map(async(field,idx) => {

        const _scaleImage = []
        const _scaleImageTimeStamp = []
    
        try {
          for (const file of field.scaleImage) {
            const params = { key: uuid(), bucketType: 'tickets', user_id: user?.user_id };
        
            
              const result = await client.post(GET_PRE_SIGNED_URL, params);
              if (result?.data?.key) {
                console.log(result?.data?.url);
        
                // Upload the file to the generated URL
                const uploadResult = await client.put(result.data.url, file);
        
                if (uploadResult?.status === 200) {
                  _scaleImageTimeStamp.push({
                    timestamp: moment.utc().format(),
                    key: result.data.key
                  })
                  _scaleImage.push(result.data.key)
                }
              }
          }
        } catch (error) {
          console.error('Error uploading file:', error);
          _showMessage(t('FAILED_TO_UPLOAD_SCALE_IMAGE_MESSAGE'))
          return
        }
    
        let payload = {
          truck_id: field.truck_id.value,
          job_id: JsonGetById.job_info_id,
          driver_id: field.driver_id.value,
          date:  field.date,
          time: buildTicketTimePayload(field),
          wait_time: field.wait_time,
          wait_duration: field.wait_duration,
          status: field.status,
          qty: field.qty,
          scale_no: field.scale_no,
          scale_image: _scaleImage,
          tk_duration: field.tk_duration,
          token: `${token}`,
          comp_acct: field.driver_id.comp_acct,
          user_id: user?.staff ? user?.staff?.staff_u_id : user?.user_id,
          scale_image_timestamp : JSON.stringify(_scaleImageTimeStamp),
          confirm_insert_shift: options.confirm_insert_shift === true,
        };

        if  (currentLocation?.latitude && currentLocation?.longitude) {
            payload.latitude = currentLocation?.latitude
            payload.longitude = currentLocation?.longitude
        }
    
        
        if (field.isSub) {
          payload.comp_acct = field?.subId.value;
          payload.isSub = true;
        
        }

        if (!field.isSub) {
          const comp = data ? data?.compacctnum : user?.company?.compacctnum;
          if (field.driver_id.comp_acct != comp) {
            payload.isSub = true;
            payload.ownerop = true;
            payload.parent_comp_acct = data ? data?.compacctnum : user?.company?.compacctnum;
          }
         
    
        }

        return payload
    }))

    console.log('multiPayload::', multiPayload);
    
    let apiRes = null;
    setSubmitLoading(true)
    await ButtonLog({type:'ticket',button_name:'ticket_manual_create',info:`${JSON.stringify(multiPayload)}`})
    
    apiRes = await client.post('/ticket/manual', {payload: multiPayload});
    apiRes = await apiRes.data;

    console.log('Ticket create modal apiRes::', apiRes);

    setTicketSummary(apiRes)

    if(apiRes?.succ?.length == 1 && apiRes?.err?.length <= 0)
    {
      dispatch(
        showMessage({
          message: `${t('TICKET')} ${apiRes?.succ?.[0]?.tk_no} ${t('WAS_SUCCESSFULLY_CREATED')}`, //text or html
          autoHideDuration: 6000, //ms
          anchorOrigin: {
            vertical: 'top', //top bottom
            horizontal: 'right', //left center right
          },
          variant: 'success', //success error info warning null
        })
      );
      onClose()
      getTickets()
    } 
    else if(apiRes?.err?.length == 1 && apiRes?.succ?.length <= 0)
    {
      dispatch(
        showMessage({
          message: apiRes?.err?.[0]?.err_message, //text or html
          autoHideDuration: 6000, //ms
          anchorOrigin: {
            vertical: 'top', //top bottom
            horizontal: 'right', //left center right
          },
          variant: 'error', //success error info warning null
        })
      );
    }
    else
    {
      setOpenTicketSummary(true)
    }


    setSubmitLoading(false)

    
  };

  const getS3Location = async (key) => {
    if (key != null && key != '') {
      let data = {
        key: key,
      };
      return await getDataFromS3(data);
    }
  };

  const getsubs = async (info) => {
    try {
      const result = await client.post('/props/get-subcon', {
        compacctnum: data ? data.compacctnum : user?.company?.compacctnum,
      });
      const comp_subs = await result.data.subcon.map((e) => {
        return { value: e.compacctnum, label: e.compname, logo: e.logo, id: e.user_id };
      });

      comp_subs.sort((a, b) => {
        if (b.compname < a.compname) {
          return 1;
        } else {
          return -1;
        }
      });

      setSubs(comp_subs);
    } catch (error) {
      console.log(error);
    }
  };

  const getdrivers = async (info) => {
    let compacctnum = data ? data.compacctnum : user.company.compacctnum;

    try {
      if (!isSub) {
        
        //get all owner ops first
        let ownerop = await client.post('/ownerop/get', { comp_acct: compacctnum });
        ownerop = await ownerop.data.ownerops;

        //create array with all compacctnum (main company + owner ops)
        const allCompAcctNums = [compacctnum, ...ownerop.map((elem) => elem.compacctnum)];
        
        //make ONE call to get all drivers for all companies
        const driver = await client.post('/props/get-drivers', { compacctnum: allCompAcctNums });

        let comp_drivers = [];
        
        if (driver?.data?.drivers && Array.isArray(driver?.data?.drivers)) {
          // Get unique compacctnum from all drivers
          const distinctCompacctnum = [...new Set(driver.data.drivers.map(d => d.compacctnum))];

          // Process drivers by company
          distinctCompacctnum.forEach((currentCompacctnum) => {
            // Find company info for this compacctnum
            let comp_name;
            let comp_acct = currentCompacctnum;
            
            // Check if it's the main company
            if (currentCompacctnum === compacctnum) {
              comp_name = data ? data.compname : user.company.compname;
            } else {
              // Check if it's an owner operator
              const owneropMatch = ownerop.find(op => op.compacctnum === currentCompacctnum);
              if (owneropMatch) {
                comp_name = owneropMatch.compname;
                comp_acct = owneropMatch.compacctnum;
              } else {
                // Unknown company - use compacctnum as fallback
                comp_name = `Unknown (${currentCompacctnum})`;
              }
            }
            
            // Get all drivers for this company
            const companyDrivers = driver.data.drivers.filter(d => d.compacctnum === currentCompacctnum);
            
            // Add all drivers from this company to the final array
            companyDrivers.forEach(e => {
              comp_drivers.push({
                value: e.dr_user_id,
                label: e.user_fname + ' ' + e.user_lname,
                comp_name: comp_name,
                comp_acct: comp_acct,
              });
            });
          });
        }

        setdrivers(comp_drivers);
      }
      setDriverLoading(false);
    } catch (error) {
      console.log(error);
      setDriverLoading(false);
    }
  };

  const getTurcks = async () => {
    const web = 1;
    try {
    
    if (!isSub && (id || job_id)) {
      try {
        
        //get all owner ops first
        let ownerop = await client.post('/ownerop/get', {
          comp_acct: data ? data.compacctnum : user.company.compacctnum,
        });
        ownerop = await ownerop.data.ownerops;

        //create array of all user_ids
        const allUserIds = [
          data ? data.id : user.user_id,
          ...ownerop.map((elem) => elem.user_id)
        ];

        // Try sending as array first (similar to get-drivers)
        
        let comp_trucks = [];
        let singleCallSucceeded = false;

        try {
          const result = await client.post('/truck/all', { 
            comp_acct: allUserIds, 
            web 
          });
          
          // If successful, process the results
          if (result?.data && Array.isArray(result.data)) {
            
            // Process all trucks - need to get company names
            result.data.forEach((truck) => {
              let comp_name = data ? data.compname : user?.company?.compname;
              let comp_acct = getMainCompAcct();

              if (truck.comp_acct) {
                const owneropMatch = ownerop.find(op => op.user_id === truck.comp_acct);
                if (owneropMatch) {
                  comp_name = owneropMatch.compname;
                  comp_acct = owneropMatch.compacctnum;
                }
              }

              comp_trucks.push({
                value: truck.idx_trucks_p,
                label: 'No. ' + truck.t_no_truck,
                comp_name: comp_name,
                comp_acct: comp_acct,
              });
            });
            
            singleCallSucceeded = true;
          }
        } catch (arrayError) {
          console.log('[getTurcks] Array method failed, falling back to parallel calls:', arrayError.message);
        }

        // Fallback: If array method failed, use parallel calls with chunking
        if (!singleCallSucceeded) {
          
          // Process in chunks of 10 to avoid overwhelming the server
          const CHUNK_SIZE = 10;
          const chunks = [];
          
          for (let i = 0; i < allUserIds.length; i += CHUNK_SIZE) {
            chunks.push(allUserIds.slice(i, i + CHUNK_SIZE));
          }

          for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
            const chunk = chunks[chunkIndex];
            
            const truckPromises = chunk.map((user_id) => 
              client.post('/truck/all', { comp_acct: user_id, web })
            );

            const truckResults = await Promise.all(truckPromises);

            truckResults.forEach((result, index) => {
              const userIdIndex = chunkIndex * CHUNK_SIZE + index;
              const isMainCompany = userIdIndex === 0;
              const comp_name = isMainCompany 
                ? (data ? data.compname : user?.company?.compname)
                : ownerop[userIdIndex - 1].compname;
              const comp_acct = isMainCompany
                ? getMainCompAcct()
                : ownerop[userIdIndex - 1].compacctnum;

              if (result?.data && Array.isArray(result.data)) {
                result.data.forEach((e) => {
                  comp_trucks.push({
                    value: e.idx_trucks_p,
                    label: 'No. ' + e.t_no_truck,
                    comp_name: comp_name,
                    comp_acct: comp_acct,
                  });
                });
              }
            });
          }
        }

        setTrucks(comp_trucks);
      } catch (error) {
        console.log(error);
      }
    }
    setTruckLoading(false)
    } catch (error) {
      console.log('TRUCK LOADING ERROR: ', error);
      setTruckLoading(false)
    }
  };

  const getMainCompAcct = () => (data ? data.compacctnum : user?.company?.compacctnum);

  const isOwnerOpField = (field) =>
    !field.isSub &&
    field.driver_id?.comp_acct &&
    field.driver_id.comp_acct !== getMainCompAcct();

  const getFieldBilling = (field) => {
    if (field.isSub && field.subJob?.job_billing) {
      return field.subJob.job_billing;
    }
    if (isOwnerOpField(field) && field.ownerSubJob?.job_billing) {
      return field.ownerSubJob.job_billing;
    }
    return JsonGetById?.job_billing;
  };

  const suggestedQty = (billing) =>
    suggestedTicketQty(billing) ??
    suggestedTicketQty(JsonGetById?.job_billing) ??
    suggestedTicketQty(jobbilling);

  const fieldRequiresCommissionTime = (field) => getFieldBilling(field)?.commissions === true;

  const fieldRequiresTicketDuration = (field) => getFieldBilling(field)?.commissions === false;

  const getCurrentTicketDate = () => moment().format('YYYY-MM-DD');
  const getCurrentTicketTime = () => moment().format('HH:mm');

  const formatFieldTicketTime = (field) => {
    if (!field.time || !field.date) return null;
    const parsed = moment(`${field.date}T${field.time}`);
    return parsed.isValid() ? parsed.format() : null;
  };

  const buildTicketTimePayload = (field) => {
    const formatted = formatFieldTicketTime(field);
    if (formatted) return formatted;
    if (fieldRequiresCommissionTime(field)) return null;
    if (field.date) return moment(`${field.date}T00:00:00`).format();
    return moment().format();
  };

  const handleDriverChange = async (fieldId, newValue) => {
    const needsOwnerSubJob =
      newValue?.comp_acct && newValue.comp_acct !== getMainCompAcct();

    setInputFields((prev) =>
      prev.map((field) =>
        field.id === fieldId
          ? {
              ...field,
              driver_id: newValue,
              ownerSubJob: null,
              ownerSubJobLoading: needsOwnerSubJob,
              time: field.time || getCurrentTicketTime(),
            }
          : field
      )
    );

    if (!needsOwnerSubJob) {
      return;
    }

    try {
      const getsubjobid = await client.post(`/jobs/sub-from-og`, {
        sub_comp_acct: newValue.comp_acct,
        comp_acct: getMainCompAcct(),
        job_id: job_id ? job_id : id,
      });

      if (getsubjobid.err_message) {
        setInputFields((prev) =>
          prev.map((field) =>
            field.id === fieldId ? { ...field, ownerSubJobLoading: false } : field
          )
        );
        return dispatch(
          showMessage({
            message: getsubjobid.err_message,
            autoHideDuration: 6000,
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'right',
            },
            variant: 'error',
          })
        );
      }

      const subjob = await client.get(`/jobs/ticket/${getsubjobid.data.job_id}`);
      const ownerSuggested = suggestedTicketQty(subjob.data[0]?.job_billing);
      const parentSuggested =
        suggestedTicketQty(JsonGetById?.job_billing) ?? suggestedTicketQty(jobbilling);
      setInputFields((prev) =>
        prev.map((field) => {
          if (field.id !== fieldId) return field;
          const untouched =
            field.qty == null ||
            field.qty === '' ||
            (parentSuggested != null && String(field.qty) === String(parentSuggested));
          return {
            ...field,
            ownerSubJob: subjob.data[0],
            ownerSubJobLoading: false,
            ...(untouched && ownerSuggested != null ? { qty: ownerSuggested } : {}),
          };
        })
      );
    } catch (error) {
      console.log(error);
      setInputFields((prev) =>
        prev.map((field) =>
          field.id === fieldId ? { ...field, ownerSubJobLoading: false } : field
        )
      );
    }
  };

  const ErrorValidation = () => {
    let error_flag = false;
    const newInputFields = syncTicketTimeFieldsFromDom(inputFields).map((field) => ({
      ...field,
      wait_duration: `${field.wait_durationhr}:${field.wait_durationmin}`,
      tk_duration: `${field.tk_durationhr}:${field.tk_durationmin}`,
    }));

    newInputFields.forEach((field) => {
        field.err_obj = {};

        if (field.isSub && !field.subId) {
            error_flag = true;
            field.err_obj.sub = t('PLEASE_SELECT_A_SUB_COMPANY');
        }
    
        if (field.truck_id == null || field.truck_id == undefined) {
            error_flag = true;
            field.err_obj.truck_id = t('PLEASE_SELECT_A_TRUCK_NO');
        }
        if (field.driver_id == null || field.driver_id == undefined) {
            error_flag = true;
            field.err_obj.driver_id = t('PLEASE_SELECT_A_DRIVER');
        }
        if (field.wait_time) {
            if (!field.wait_durationhr) {
                error_flag = true;
                field.err_obj.wait_duration = t('PLEASE_ENTER_A_WAIT_DURATION');
            }
            if (!field.wait_durationmin) {
                error_flag = true;
                field.err_obj.wait_duration = t('PLEASE_ENTER_A_WAIT_DURATION');
            }
            if (
                field.wait_duration == null ||
                field.wait_duration == undefined ||
                field.wait_duration == ':'
            ) {
                error_flag = true;
                field.err_obj.wait_duration = t('PLEASE_ENTER_A_WAIT_DURATION');
            }
        }
        if (field.qty == null || field.qty == undefined || field.qty == '') {
            error_flag = true;
            field.err_obj.qty = t('PLEASE_ENTER_A_QUANTITY');
        }
        if (isManualTicketDateMissing(field.date)) {
            error_flag = true;
            field.err_obj.date = t('PLEASE_ENTER_A_DATE');
        }
        if (field.ownerSubJobLoading) {
            error_flag = true;
            field.err_obj.driver_id = t('PLEASE_FIX_THE_ERRORS');
        }

        if (fieldRequiresTicketDuration(field)) {
            if (!field.tk_durationhr) {
                error_flag = true;
                field.err_obj.tk_duration = t('PLEASE_ENTER_A_DURATION_FOR_THE_TICKET');
            }
            if (!field.tk_durationmin) {
                error_flag = true;
                field.err_obj.tk_duration = t('PLEASE_ENTER_A_DURATION_FOR_THE_TICKET');
            }
            if (
                field.tk_duration == null ||
                field.tk_duration == undefined ||
                field.tk_duration == ':'
            ) {
                error_flag = true;
                field.err_obj.tk_duration = t('PLEASE_ENTER_A_DURATION_FOR_THE_TICKET');
            } else {
                if (
                field.wait_duration != null ||
                field.wait_duration != undefined ||
                field.wait_duration != ':'
                ) {
                    const test_wtd = moment(
                        `${moment().format('YYYY-MM-DD')} ${field.wait_duration}`
                    ).format();
                    const test_tkd = moment(
                        `${moment().format('YYYY-MM-DD')} ${field.tk_duration}`
                    ).format();

                    if (moment(test_wtd).isAfter(test_tkd) == true) {
                        error_flag = true;
                        field.err_obj.wait_duration = t('WAIT_DURATION_MUST_BE_LESS_THAN_TICKET_DURATION');
                    }
                }
            }
        }

        if (fieldRequiresCommissionTime(field)) {
            if (isManualTicketTimeMissing(field.time)) {
                error_flag = true;
                field.err_obj.time = t('PLEASE_ENTER_A_TIME');
            }
        }
        
    
        
    
        if (JsonGetById.scale == true) {
        if (field.scale_no.length <= 0 || !field.scale_no) {
            error_flag = true;
            field.err_obj.scale_no = t('PLEASE_ENTER_A_SCALE_HASTAG');
        }
        }
    
    
        if (ticketTruckDriverCompanyMismatch(field?.driver_id, field?.truck_id)) {
        error_flag = true;
        field.err_obj.driver_id = t('TRUCK_AND_DRIVER_COMPANY_DOES_NOT_MATCH');
        field.err_obj.truck_id = t('TRUCK_AND_DRIVER_COMPANY_DOES_NOT_MATCH');
        }
      
    })

    setInputFields(newInputFields)

    return error_flag;
  };

  const handleDeleteEditScaleImage = (id,index) => {
    const newInputFields = [...inputFields]
    newInputFields.map((field,idx) => {
        if (field.id === id) {
            const newImages = field.scaleImage;
            newImages.splice(index, 1);
            field.scaleImage = newImages;
        }
    })
    setInputFields([...newInputFields])

   /*  let newImages = scaleImage;
    newImages.splice(index, 1);
    setScaleImage([...newImages]); */
  }

  const handleAddEditScaleImage = (key) => {
    const limit = scaleTicketImageUploadLimit ?? DEFAULT_SCALE_IMAGE_UPLOAD_LIMIT

    const newInputFields = [...inputFields]
    newInputFields.map((field,idx) => {
        if (field.id === fieldId) {
            if (field.scaleImage.length >= limit) {
                _showMessage(`${t('NOT_ALLOWED_TO_UPLOAD_MORE_THAN')} ${limit} ${t('IMAGE')}`)
            }
            else
            {
                field.scaleImage.push(key)
            }
        }
    })
    setInputFields([...newInputFields])
    setFieldId(null)
    /* if (scaleImage.length >= limit) {
      _showMessage(`Not allowed to upload more than ${limit} image`)
    }
    setScaleImage([...scaleImage, key]) */
  }

/*   const defaultInputFields = {
    id:uuid(),
    isSub: false,
    subId: null,
    truck_id: null,
    driver_id: null,
    date: null,
    time: null,
    wait_time: false,
    //wait_duration: '00:00',
    wait_durationhr: '',
    wait_durationmin: '',
    status: '1',
    qty: suggestedQty(),
    scale_no: '',
    tk_durationhr: '',
    tk_durationmin: '',
    scaleImage: [],
    //tk_duration: '00:00'
  } */

  //const [inputFields,setInputFields] = useState([{...defaultInputFields}])

  const changeIsSub = (id,e) => {

    if(e.target.checked && subs.length == 0)
    {
        getsubs()
    }


    const newInputFields = inputFields.map((field) => {
      if (field.id === id) {
        return {
            ...field,
            isSub: e.target.checked,
            subId: null,
            truck_id: null,
            driver_id: null,
            date: getCurrentTicketDate(),
            time: getCurrentTicketTime(),
            wait_time: false,
            //wait_duration: '00:00',
            wait_durationhr: '',
            wait_durationmin: '',
            status: '1',
            qty: suggestedQty(),
            scale_no: '',
            tk_durationhr: '',
            tk_durationmin: '',
            scaleImage: [],
            //tk_duration: '00:00'
        }
      }
      else
      {
          return field
      }
    })
    setInputFields(newInputFields)
  }

  const changeSubId = async (field_id,newValue) => {

    if(newValue)
    {
        const loadingInputFields = inputFields.map((field) => {
            if (field.id === field_id) {
            return {
                ...field,
                loading:true,
                subLogoLoading: true,
                subId: newValue,
                subTrucks:[],
                subDrivers: [],
                truck_id: null,
                driver_id: null,
                date: getCurrentTicketDate(),
                time: getCurrentTicketTime(),
                wait_time: false,
                //wait_duration: '00:00',
                wait_durationhr: '',
                wait_durationmin: '',
                status: '1',
                qty: suggestedQty(),
                scale_no: '',
                tk_durationhr: '',
                tk_durationmin: '',
                scaleImage: [],
                //tk_duration: '00:00'
            }
            }
            else
            {
                return field
            }
        })
        setInputFields(loadingInputFields)


        let getsubjobid = await client.post(`/jobs/sub-from-og`, {
            sub_comp_acct: newValue.value,
            comp_acct: data ? data.compacctnum : user?.company?.compacctnum,
            job_id: job_id ? job_id : id,
        });

        console.log('subjobid::', getsubjobid);

        if (getsubjobid.err_message) {
        const loadingErrorInputFields = inputFields.map((field) => {
            if (field.id === field_id) {
                return {
                    ...field,
                    loading:false,
                    subId: newValue,
                    subTrucks:[],
                    subDrivers: [],
                    truck_id: null,
                    driver_id: null,
                    date: getCurrentTicketDate(),
                    time: getCurrentTicketTime(),
                    wait_time: false,
                    //wait_duration: '00:00',
                    wait_durationhr: '',
                    wait_durationmin: '',
                    status: '1',
                    qty: suggestedQty(),
                    scale_no: '',
                    tk_durationhr: '',
                    tk_durationmin: '',
                    //tk_duration: '00:00'
                }
            }
            else
            {
                return field
            }
            })
        setInputFields(loadingErrorInputFields)

        return dispatch(
            showMessage({
            message: getsubjobid.err_message, //text or html
            autoHideDuration: 6000, //ms
            anchorOrigin: {
                vertical: 'top', //top bottom
                horizontal: 'right', //left center right
            },
            variant: 'error', //success error info warning null
            })
        );
        }

        const subjob = await client.get(`/jobs/ticket/${getsubjobid.data.job_id}`);
        console.log('inputField?.subJob >> ', subjob);

        let comp_drivers = [];
        try {
            
            console.log('driver::2');
            const driver = await client.post('/props/get-drivers', { compacctnum: newValue.value });
            comp_drivers = driver.data.drivers.map((e) => {
            return {
                value: e.dr_user_id,
                label: e.user_fname + ' ' + e.user_lname,
                comp_name: newValue.label,
                comp_acct: newValue.value,
            };
            });
            console.log('driver::1', comp_drivers);
        } catch (error) {
        console.log(error);
        const loadingErrorInputFields = inputFields.map((field) => {
            if (field.id === field_id) {
                return {
                    ...field,
                    loading:false,
                    subId: newValue,
                    subTrucks:[],
                    subDrivers: [],
                    truck_id: null,
                    driver_id: null,
                    date: getCurrentTicketDate(),
                    time: getCurrentTicketTime(),
                    wait_time: false,
                    //wait_duration: '00:00',
                    wait_durationhr: '',
                    wait_durationmin: '',
                    status: '1',
                    qty: suggestedQty(),
                    scale_no: '',
                    tk_durationhr: '',
                    tk_durationmin: '',
                    //tk_duration: '00:00'
                }
            }
            else
            {
                return field
            }
        })
        setInputFields(loadingErrorInputFields)

        return dispatch(
            showMessage({
            message: t('ERROR_GETTING_DRIVERS'), //text or html
            autoHideDuration: 6000, //ms
            anchorOrigin: {
                vertical: 'top', //top bottom
                horizontal: 'right', //left center right
            },
            variant: 'error', //success error info warning null
            })
        );
        }


        let comp_trucks = []
        try {
        const result = await client.post('/truck/all', {web:1, comp_acct: newValue.id });
        comp_trucks = await result.data.map((e) => {
            return { value: e.idx_trucks_p, label: 'No. ' + e.t_no_truck, comp_name: newValue.label };
        });

        } catch (error) {
        console.log(error);
        const loadingErrorInputFields = inputFields.map((field) => {
            if (field.id === field_id) {
                return {
                    ...field,
                    loading:false,
                    subId: newValue,
                    subTrucks:[],
                    subDrivers: [],
                    truck_id: null,
                    driver_id: null,
                    date: getCurrentTicketDate(),
                    time: getCurrentTicketTime(),
                    wait_time: false,
                    //wait_duration: '00:00',
                    wait_durationhr: '',
                    wait_durationmin: '',
                    status: '1',
                    qty: suggestedQty(),
                    scale_no: '',
                    tk_durationhr: '',
                    tk_durationmin: '',
                    //tk_duration: '00:00'
                }
            }
            else
            {
                return field
            }
        })
        setInputFields(loadingErrorInputFields)

        return dispatch(
            showMessage({
            message: t('ERROR_GETTING_TRUCKS'), //text or html
            autoHideDuration: 6000, //ms
            anchorOrigin: {
                vertical: 'top', //top bottom
                horizontal: 'right', //left center right
            },
            variant: 'error', //success error info warning null
            })
        );
        }
        

        const newInputFields = inputFields.map((field) => {
        if (field.id === field_id) {
            return {
                ...field,
                loading:false,
                subLogoLoading: false,
                subLogo: newValue.logo,
                subJob:subjob.data[0],
                subId: newValue,
                subTrucks: comp_trucks,
                truck_id: null,
                subDrivers: comp_drivers,
                driver_id: null,
                date: getCurrentTicketDate(),
                time: getCurrentTicketTime(),
                wait_time: false,
                //wait_duration: '00:00',
                wait_durationhr: '',
                wait_durationmin: '',
                status: '1',
                qty: suggestedQty(subjob.data[0]?.job_billing),
                scale_no: '',
                tk_durationhr: '',
                tk_durationmin: '',
                //tk_duration: '00:00'
            }
        }
        else
        {
            return field
        }
        })
        setInputFields(newInputFields)
    }
    else
    {
        const newInputFields = inputFields.map((field) => {
            if (field.id === field_id) {
                return {
                    ...field,

                    subId: newValue,
                    subTrucks: null,
                    truck_id: null,
                    subDrivers: null,
                    driver_id: null,
                    date: getCurrentTicketDate(),
                    time: getCurrentTicketTime(),
                    wait_time: false,
                    //wait_duration: '00:00',
                    wait_durationhr: '',
                    wait_durationmin: '',
                    status: '1',
                    qty: suggestedQty(),
                    scale_no: '',
                    tk_durationhr: '',
                    tk_durationmin: '',
                    //tk_duration: '00:00'
                }
            }
            else
            {
                return field
            }
            })
            setInputFields(newInputFields)
    }
  }

  const handleInputField = (id,value) => {
    setInputFields((prevFields) =>
      prevFields.map((field) => {
        if (field.id !== id) {
          return field;
        }

        const err_obj = { ...(field.err_obj ?? {}) };
        Object.keys(value).forEach((key) => {
          delete err_obj[key];
        });

        return {
          ...field,
          ...value,
          err_obj,
        };
      })
    );
  }

  const [fieldId,setFieldId] = useState(null)

  const handleSubmit = async() => {
    const err = ErrorValidation();
    if (!err) {
      const needsShiftInsert = inputFields.some((field) => fieldRequiresTicketDuration(field));
      if (needsShiftInsert) {
        setOpenShiftConfirm(true);
      } else {
        submitManualCreateTicket();
      }
    } else {
        return dispatch(
            showMessage({
              message: t('PLEASE_FIX_THE_ERRORS'), //text or html
              autoHideDuration: 6000, //ms
              anchorOrigin: {
                vertical: 'top', //top bottom
                horizontal: 'right', //left center right
              },
              variant: 'error', //success error info warning null
            })
          );
    }
}

  const handleConfirmShiftInsert = () => {
    setOpenShiftConfirm(false);
    submitManualCreateTicket({ confirm_insert_shift: true });
  };

const handleAddInputField = () => {
  const err = ErrorValidation();
  if(!err)
  {
    setInputFields((prevFields) => [...prevFields, { ...defaultInputFields, id: uuid() }]);
  }
  else
  {
    return dispatch(
        showMessage({
          message: t('PLEASE_FIX_THE_ERRORS'), //text or html
          autoHideDuration: 6000, //ms
          anchorOrigin: {
            vertical: 'top', //top bottom
            horizontal: 'right', //left center right
          },
          variant: 'error', //success error info warning null
        })
      );
}
}

const handleRemoveInputField = (id) => {
  setInputFields(inputFields.filter(field => field.id !== id))
}

const inputFieldRefs = useRef({}); // Store refs for each inputField

const scrollToInputField = (id) => {
  if (inputFieldRefs.current[id]) {
    const element = inputFieldRefs.current[id];

    element.scrollIntoView({
      behavior: "smooth", // Smooth scrolling
      block: "nearest",   // Prevent unnecessary shifting of the parent container
      inline: "nearest",  // Ensure horizontal alignment is also preserved
    });
    
     // Add the bounce animation class
     element.classList.add("grow-animation");

     // Remove the class after the animation ends
     setTimeout(() => {
      element.classList.remove("grow-animation");
     }, 1000); // Match the duration of the animation
  }
};



  return (
    <>


      <TicketScaleImageUploader
        user={user}
        handleAddEditScaleImage={handleAddEditScaleImage}
        open={openScaleImageUploader}
        setOpen={setOpenScaleImageUploader}
        setFieldId={setFieldId}
      />

      <Dialog
      open={submitLoading}
      >
        <FuseLoading/>
      </Dialog>

      <Dialog
        open={openShiftConfirm}
        onClose={() => setOpenShiftConfirm(false)}
        aria-labelledby="manual-create-shift-confirm-title-table"
      >
        <DialogTitle id="manual-create-shift-confirm-title-table">
          {t('MANUAL_CREATE_SHIFT_CONFIRM_TITLE')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('MANUAL_CREATE_SHIFT_CONFIRM_MESSAGE')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenShiftConfirm(false)} color="inherit">
            {t('CANCEL')}
          </Button>
          <Button onClick={handleConfirmShiftInsert} variant="contained" autoFocus>
            {t('MANUAL_CREATE_SHIFT_CONFIRM_CONTINUE')}
          </Button>
        </DialogActions>
      </Dialog>

      <TicketCreateSummary
        data={ticketSummary}
        open={openTicketSummary}
        handleClose={handleSummaryClose}
      />


      <div>
        <Dialog
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          fullWidth={true}
          open={open}
          sx={{
            '& .MuiDialog-paper': {
              width: '100%',
              maxWidth: '2000px', 
              maxHeight:'95vh',
              height:'100%'
            },
          }} 
        >
          <DialogTitle>
            <div
            className="form-header flex justify-between items-center"
            style={{ padding: '10px 30px' }}
            >
                <div className="form-title">
                    <h2 className="font-bold">{t('CREATE_TICKET')}</h2>
                </div>
                
                <div className='flex flex-row justify-center align-center items-center'>
                  {/**errors button */}
                  {ticketSummary?.err.length >=1 ? <div style={{marginRight:'10px'}}>
                        <Tooltip title={t('VIEW_ERRORS')}>
                            <IconButton 
                                sx={{'&:hover':{backgroundColor:'#e9c917'},backgroundColor:'#e9c917'}}
                                onClick={() => {setOpenTicketSummary(!openTicketSummary)}}
                            >
                                <ErrorOutlineIcon/>
                            </IconButton>
                        </Tooltip>
                  </div>:null}

                  {/**view button */}
                  <div style={{marginRight:'10px'}}>
                      <Tooltip title={t('TICKET_VIEW')}>
                          <IconButton 
                              sx={{'&:hover':{backgroundColor:'#e9c917'},backgroundColor:'#e9c917'}}
                              onClick={() => {setMultiTicketView(!multiTicketView)}}
                          >
                              <ChangeCircleIcon/>
                          </IconButton>
                      </Tooltip>
                  </div>
                  
                  {/**close button */}
                  <div
                      className="text-white close-x-btn"
                      style={{ marginTop: '0',cursor:'pointer' }}
                      onClick={onClose}
                      sx={printpdf}
                  >
                  

                      <div className="close-btn" >
                      <img
                          width="25px"
                          height="25px"
                          src="/assets/images/icons/icons8-close-white.svg"
                      />
                      </div>
                  </div>
                </div>
            </div>
          </DialogTitle>

          <DialogContent className='flex flex-col '>
            
            {
              loading ? 
                <FuseLoading/>
              :  
                <Box className={`overflow-y-scroll onprint relative p-0 m-0 h-full md:h-auto`}
                >
                   
                    {
                        inputFields.map((inputField,idx) => {
                            return(
                            <TableContainer className='pb-20 relative'  id={'tableContainer_'+inputField.id} >
                                <Table>
                                    <TableHead>
                                        <TableRow
                                            style={{
                                                background:inputField?.wait_time
                                                ? 'red'
                                                : inputField?.isSub
                                                ? 'black'
                                                : '#e9c917',
                                                border: inputField?.wait_time
                                                ? '1px solid red'
                                                : inputField?.isSub
                                                ? '1px solid black'
                                                : '1px solid #e9c917',
                                                boxShadow: inputField?.wait_time
                                                ? '0 0 2px red'
                                                : inputField?.isSub
                                                ? '0 0 2px black'
                                                : '0 0 2px #e5c617',
                                                minWidth:'174px'
                                            }}
                                        >
                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'100px',padding:'8px'}} align='left'></TableCell>{/**logo goes here */}

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'120px',padding:'8px'}} align='left'>{t('COMP')} - {t('SUBS')}</TableCell>

                                            {inputField?.isSub ? <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('SUBCONTRACTORS')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.sub ? '*' : ''}</p></div></TableCell> : null}

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'90px',padding:'8px'}} align='left'>{t('JOB_NO')}</TableCell>

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'>{t('CUSTOMER')}</TableCell>

                                            {/* <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'>Quarry Name</TableCell> */}

                                            {/* <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'>Destination</TableCell> */}

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('TRUCK_HASTAG')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.truck_id ? '*' : ''}</p></div></TableCell>

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('DRIVER')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.driver_id ? '*' : ''}</p></div></TableCell>

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('TIME')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.time ? '*' : ''}</p></div></TableCell>

                                            {
                                                fieldRequiresCommissionTime(inputField) ?
                                                    <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('DATE')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.date ? '*' : ''}</p></div></TableCell> 
                                                    : 
                                                    null
                                            }

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'120px',padding:'8px'}} align='left'>{t('WAIT_TIME')}</TableCell>
                                            {inputField?.wait_time ? <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('WAIT_DURATION')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.wait_duration ? '*' : ''}</p></div></TableCell> : null}


                                            {
                                                fieldRequiresTicketDuration(inputField) ?
                                                    <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('TICKET_DURATION')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.tk_duration ? '*' : ''}</p></div></TableCell> 
                                                    : 
                                                    null
                                            }


                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'>{t('STATUS')}</TableCell>

                                            

                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'80px',width:'100%',padding:'8px'}} align='left'><div className='flex'>{t('QTY')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.qty ? '*' : ''}</p></div></TableCell>
                                            {JsonGetById?.scale ? <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'><div className='flex'>{t('SCALE_NO')}<p style={{ color:inputField?.wait_time ? 'black' : 'red', fontSize: 20 }}>{inputField?.err_obj?.scale_no ? '*' : ''}</p></div></TableCell> : null}
                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',maxWidth:'125px',width:'100%',padding:'8px'}} align='left'>{t('UNITS')}</TableCell>
                                            <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',minWidth:'174px',padding:'8px'}} align='left'>{t('MATERIAL')}</TableCell>

                                            {
                                                JsonGetById?.scale ? 
                                                <TableCell sx={{ color:inputField?.wait_time ? 'white' : inputField?.isSub ? 'white' : 'black',height:'80px',maxWidth:'90px',padding:'8px'}} align='left'>
                                                  <div className='flex align-center items-center'>{t('IMAGES')}
                                                    {
                                                        allowToUploadScaleTicketImage && 
                                                        <IconButton 
                                                            sx={{
                                                            padding:0,
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            height:'33px',
                                                            width:'33px',
                                                            }}
                                                            onClick={(e) => {
                                                            e.stopPropagation(); 
                                                            setOpenScaleImageUploader(true);
                                                            setFieldId(inputField?.id);
                                                            }}
                                                        >
                                                            <AddIcon sx={{ background:'black',color:'#edca33',border:3,borderRadius:5,borderColor:'#edca33'}} fontSize='20px' />
                                                        </IconButton>
                                                    }
                                                  </div>
                                                </TableCell> 
                                                : 
                                                null
                                            }
                                            
                                        </TableRow>
                                    </TableHead>
                                    
                                    {/**table */}
                                    <TableBody>
                                        <TableRow 
                                            sx={{
                                                borderBottom: '2px dashed black', // Increase border width to make dashes larger
                                                borderImage: 'repeating-linear-gradient(to right, black 0, black 10px, transparent 10px, transparent 20px) 2', // Adjust dash size and spacing
                                            }}
                                        >

                                            <TableCell sx={{height:'80px', minWidth:'100px',padding:'8px'}} align='left'>{/**logo goes here */}
                                                {
                                                    inputField?.subLogoLoading ? <CircularLoader/> 
                                                : 
                                                    <img
                                                        alt="Logo"
                                                        src={inputField?.isSub && inputField?.subId ? inputField?.subLogo : logo}
                                                        style={{ width: '100%' }}
                                                    />
                                                }
                                            </TableCell>

                                            <TableCell sx={{height:'80px', minWidth:'120px',padding:'8px'}} align='left'>
                                                <Switch
                                                    checked={inputField?.isSub}
                                                    onChange={(e) => {
                                                        changeIsSub(inputField?.id,e);
                                                        //setIsSub(e.target.checked);
                                                        //setSubId(null);
                                                        //formikRef.current?.resetForm();
                                                        //setChecked(false);
                                                    }}
                                                />
                                            </TableCell>

                                            {
                                                inputField?.isSub ? 
                                                    <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                        <Autocomplete
                                                            disableListWrap
                                                            id="subs-auto-complete"
                                                            value={inputField?.subId}
                                                            options={subs}
                                                            onChange={(e, newValue) => {
                                                                //setSubId(newValue);
                                                                changeSubId(inputField?.id,newValue)
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                id="subs-field"
                                                                {...params}
                                                                placeholder={t('SUB_COMP')}
                                                                sx={{ padding: 0 }}
                                                                />
                                                            )}
                                                        />
                                                    </TableCell> 
                                                    : 
                                                    null
                                            }

                                            <TableCell sx={{height:'80px', minWidth:'90px',padding:'8px'}} align='left'>
                                                {inputField?.isSub && inputField?.subId ? inputField?.subJob?.company_id : JsonGetById?.company_id}-{inputField?.isSub && inputField?.subId ? inputField?.subJob?.job_no : JsonGetById?.job_no}
                                            </TableCell>

                                            <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                {inputField?.isSub && inputField?.subId ? inputField?.subJob?.customer_name : JsonGetById?.customer_name}
                                            </TableCell>

                                            {/* <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                <LocationOnIcon /> {inputField?.isSub && inputField?.subId ? inputField?.subJob?.quarry_pit?.l_name :  JsonGetById?.quarry_pit?.l_name}
                                            </TableCell> */}

                                            {/* <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                <LocationOnIcon /> {inputField?.isSub && inputField?.subId ? inputField?.subJob?.j_destination?.l_name :  JsonGetById?.j_destination?.l_name}
                                            </TableCell> */}

                                            <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                {
                                                    truckLoading || inputField?.loading ? <CircularLoader/> :
                                                
                                                    <Autocomplete
                                                    disabled={inputField?.isSub && !inputField?.subId ? true : false}
                                                    name="truck_id"
                                                    disableListWrap
                                                    id="truck-auto-complete"
                                                    value={inputField?.truck_id}
                                                    options={inputField?.isSub && inputField?.subId ? inputField?.subTrucks : trucks}
                                                    groupBy={(option) => option.comp_name}
                                                    getOptionLabel={(option) => option.label}
                                                    filterOptions={(options, { inputValue }) => {
                                                      const search = inputValue.toLowerCase();
                                                      //console.log('SEARCH: ', search)
                                                      return options.filter(option =>
                                                        option.label.toLowerCase().includes(search) ||
                                                        (option.comp_name && option.comp_name.toLowerCase().includes(search))
                                                      );
                                                    }}
                                                    onChange={(e, newValue) => {
                                                        handleInputField(inputField?.id,{truck_id : newValue});
                                                        //setFieldValue('truck_id', newValue);
                                                        console.log(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                        id="truck-field"
                                                        {...params}
                                                        placeholder={t('TRUCK_NO')}
                                                        sx={{ padding: 0 }}
                                                        />
                                                    )}
                                                    renderGroup={(params) => (
                                                        <li>
                                                        <GroupHeader>{params.group}</GroupHeader>
                                                        <GroupItems>{params.children}</GroupItems>
                                                        </li>
                                                    )}
                                                    />
                                                }
                                            </TableCell>

                                            <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                {
                                                    driverLoading || inputField?.loading ? <CircularLoader/> :
                                                    
                                                    <Autocomplete
                                                        //onKeyDown={(e)=>{if(e.key = 'tab'){document.getElementById("truck-auto-complete").focus()}}}
                                                        disabled={inputField?.isSub && !inputField?.subId ? true : false}
                                                        name="driver_id"
                                                        disableListWrap
                                                        id="driver-auto-complete"
                                                        value={inputField?.driver_id}
                                                        options={inputField?.isSub && inputField?.subId ? inputField?.subDrivers : drivers}
                                                        groupBy={(option) => option.comp_name}
                                                        getOptionLabel={(option) => option.label}
                                                        filterOptions={(options, { inputValue }) => {
                                                          const search = inputValue.toLowerCase();
                                                          //console.log('SEARCH: ', search)
                                                          return options.filter(option =>
                                                            option.label.toLowerCase().includes(search) ||
                                                            (option.comp_name && option.comp_name.toLowerCase().includes(search))
                                                          );
                                                        }}
                                                        onChange={(e, newValue) => {
                                                        //setFieldValue('driver_id', newValue);
                                                        //console.log('NEW VALUE DRIVER > ', newValue);
                                                        handleDriverChange(inputField?.id, newValue);
                                                        }}
                                                        renderInput={(params) => (
                                                        <TextField
                                                            autoFocus
                                                            {...params}
                                                            placeholder={t('DRIVER')}
                                                            sx={{ padding: 0 }}
                                                        />
                                                        )}
                                                        renderGroup={(params) => (
                                                        <li>
                                                            <GroupHeader>{params.group}</GroupHeader>
                                                            <GroupItems>{params.children}</GroupItems>
                                                        </li>
                                                        )}
                                                    />
                                                }
                                            </TableCell>

                                            {
                                                fieldRequiresCommissionTime(inputField) ?
                                                    <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                        <input
                                                            name="time"
                                                            value={inputField?.time ?? ''}
                                                            className="border text-sm text-black w-full p-8"
                                                            data-ticket-field-id={inputField?.id}
                                                            data-ticket-field-type="time"
                                                            type="time"
                                                            onChange={(e) => {
                                                                handleInputField(inputField?.id, {time:e.target.value});
                                                            }}
                                                        />
                                                    </TableCell> 
                                                    : 
                                                    null
                                            }

                                            <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                <input
                                                    name="date"
                                                    value={inputField?.date ?? ''}
                                                    className="w-full border text-sm text-black p-8"
                                                    data-ticket-field-id={inputField?.id}
                                                    data-ticket-field-type="date"
                                                    type="date"
                                                    onChange={(e) => {
                                                        handleInputField(inputField?.id, {date:e.target.value});
                                                    }}
                                                />
                                            </TableCell>

                                            <TableCell sx={{height:'80px', minWidth:'120px',padding:'8px'}} align='left'>
                                                <Switch
                                                    name="wait_time"
                                                    checked={inputField?.wait_time}
                                                    onChange={(e) => {
                                                    handleInputField(inputField?.id, {wait_time:e.target.checked});
                                                    }}
                                                />
                                            </TableCell>

                                            {
                                                inputField?.wait_time ? 
                                                    <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                        <div className='flex flex-row justify-center align-center items-center'>
                                                            <TextField
                                                                value={inputField?.wait_durationhr}
                                                                sx={{ width: '30%', padding:0, '& .MuiInputBase-input': { padding:0,paddingTop: '6px'} }}
                                                                onChange={(e) => {
                                                                    handleInputField(inputField?.id, {wait_durationhr:e.target.value});
                                                                }}
                                                                inputProps={{ maxLength: 2 }}
                                                                onInput={(e) => {
                                                                    if (!time_regex.test(e.target.value)) {
                                                                    e.target.value = e.target.value.slice(0, -1);
                                                                    }
                                                                }}
                                                                size="small"
                                                            />

                                                            <Typography
                                                                sx={{ paddingTop: 2, paddingRight: 1 }}
                                                                fontSize={12}
                                                            >
                                                                {t('HRS')}
                                                            </Typography>

                                                            <Typography
                                                                className=""
                                                                fontSize={24}
                                                            >
                                                                :
                                                            </Typography>

                                                            <TextField
                                                                value={inputField?.wait_durationmin}
                                                                sx={{ width: '30%', padding:0, '& .MuiInputBase-input': { padding:0,paddingTop: '6px'} }}
                                                                onChange={(e) => {
                                                                    handleInputField(inputField?.id, {wait_durationmin:e.target.value});
                                                                }}
                                                                inputProps={{ maxLength: 2 }}
                                                                onInput={(e) => {
                                                                    if (!time_regex.test(e.target.value)) {
                                                                    e.target.value = e.target.value.slice(0, -1);
                                                                    }
                                                                }}
                                                                size="small"
                                                            />

                                                            <Typography
                                                                sx={{ paddingTop: 2, paddingLeft: 0 }}
                                                                fontSize={12}
                                                            >
                                                                {t('MIN')}
                                                            </Typography>
                                                        </div>
                                                    </TableCell> 
                                                    : 
                                                    null
                                            }


                                            {
                                                fieldRequiresTicketDuration(inputField) ?
                                                    <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                      <div className='flex flex-row justify-center align-center items-center'>
                                                        <TextField
                                                            value={inputField?.tk_durationhr}
                                                            sx={{ width: '30%', padding:0, '& .MuiInputBase-input': { padding:0,paddingTop: '6px' } }}
                                                            onChange={(e) => {
                                                            handleInputField(inputField?.id, {tk_durationhr:e.target.value});
                                                            }}
                                                            inputProps={{ maxLength: 2,padding:0 }}
                                                            onInput={(e) => {
                                                            if (!time_regex.test(e.target.value)) {
                                                                e.target.value = e.target.value.slice(0, -1);
                                                            }
                                                            }}
                                                            size="small"
                                                        />
                                                        <Typography
                                                            sx={{ paddingTop: 2, paddingRight: 1 }}
                                                            fontSize={12}
                                                        >
                                                            {t('HRS')}
                                                        </Typography>
                                                        <Typography
                                                            className=""
                                                            fontSize={24}
                                                        >
                                                            :
                                                        </Typography>
                                                        <TextField
                                                            value={inputField?.tk_durationmin}
                                                            sx={{ width: '30%', padding:0, '& .MuiInputBase-input': { padding:0,paddingTop: '6px'}  }}
                                                            onChange={(e) => {
                                                                handleInputField(inputField?.id, {tk_durationmin:e.target.value});
                                                            }}
                                                            inputProps={{ maxLength: 2 }}
                                                            onInput={(e) => {
                                                            if (!time_regex.test(e.target.value)) {
                                                                e.target.value = e.target.value.slice(0, -1);
                                                            }
                                                            }}
                                                            size="small"
                                                        />
                                                        <Typography
                                                            sx={{ paddingTop: 2, paddingLeft: 0 }}
                                                            fontSize={12}
                                                        >
                                                            {t('MIN')}
                                                        </Typography>
                                                      </div>
                                                    </TableCell> 
                                                    : 
                                                    null
                                            }


                                            <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                <Select //here
                                                    component="select"
                                                    name="status"
                                                    type='select'
                                                    value={inputField?.status}
                                                    placeholder={t('STATUS')}
                                                    className="w-full text-sm text-black p-10 border"
                                                    style={{ appearance: 'auto' }}
                                                    inputProps={{sx:{padding:'8px'}}}
                                                    onChange={(e) => {
                                                        handleInputField(inputField?.id, {status:e.target.value});
                                                    }}
                                                >
                                                    <MenuItem
                                                    disabled
                                                    value=""
                                                    selected
                                                    style={{padding:'4px'}}
                                                    >
                                                    {t('SELECT_STATUS')}
                                                    </MenuItem>
                                                    <MenuItem style={{padding:'4px'}} value="0">{t('IN_PROGRESS')}</MenuItem>
                                                    <MenuItem style={{padding:'4px'}} value="1">{t('COMPLETE')}</MenuItem>
                                                    <MenuItem style={{padding:'4px'}} value="2">{t('DELAY')}</MenuItem>
                                                </Select >
                                            </TableCell>

                                            

                                            <TableCell sx={{height:'80px', maxWidth:'80px',width:'100%',padding:'8px'}} align='left'>
                                                <TextField //here
                                                    name="qty"
                                                    value={inputField?.qty}
                                                    className="border w-full text-center"
                                                    placeholder={t('QTY')}
                                                    type="text"
                                                    inputProps={{sx:{padding:'5px'}}}
                                                    //sx={{'& .MuiInputBase-input': { padding:0}  }}

                                                    onChange={(e) => {
                                                    handleInputField(inputField?.id, {qty:e.target.value});
                                                    }}
                                                    onInput={(e) => {
                                                    if (!regex.test(e.target.value)) {
                                                        e.target.value = e.target.value.slice(0, -1);
                                                    }
                                                    }}
                                                />
                                            </TableCell>

                                            {
                                            JsonGetById?.scale ? 
                                                <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                    <TextField //here
                                                        name="scale_no"
                                                        className="border p-10 w-full text-center"
                                                        type="text"
                                                        inputProps={{sx:{padding:'5px'}}}
                                                        value={inputField?.scale_no}
                                                        placeholder={t('SCALE_NO')}
                                                        onChange={(e) => {
                                                        handleInputField(inputField?.id, {scale_no:e.target.value});
                                                        }}
                                                        onInput={(e) => {
                                                        if (!regex.test(e.target.value)) {
                                                            e.target.value = e.target.value.slice(0, -1);
                                                        }
                                                        }}
                                                    />
                                                </TableCell> 
                                                :
                                                null
                                            }

                                            <TableCell sx={{height:'80px', minWidth:'125px',width:'100%',padding:'8px'}} align='left'>
                                                <TextField //here
                                                    disabled
                                                    name="unit"
                                                    inputProps={{sx:{padding:'5px'}}}
                                                    className="border p-10 w-full text-center"
                                                    value={
                                                        JsonGetById &&
                                                        JsonGetById?.job_billing &&
                                                        JsonGetById?.job_billing.unit_name
                                                        ? JsonGetById?.job_billing.unit_name
                                                        : null
                                                    }
                                                />
                                            </TableCell>

                                            <TableCell sx={{height:'80px', minWidth:'174px',padding:'8px'}} align='left'>
                                                <TextField //here
                                                    disabled={true}
                                                    inputProps={{sx:{padding:'5px'}}}
                                                    className="border p-10 w-full text-center"
                                                    value={
                                                        JsonGetById &&
                                                        JsonGetById?.job_billing &&
                                                        JsonGetById?.job_billing.name
                                                        ? JsonGetById?.job_billing.name
                                                        : null
                                                    }
                                                />
                                            </TableCell>

                                            {
                                            JsonGetById?.scale ? 
                                                <TableCell sx={{height:'80px', maxWidth:'90px',padding:0}} align='left'>
                                                  <div className='flex flex-col justify-center align-center items-center overflow-y-scroll overflow-x-visible' style={{height:'100%',width:'100%'}}>
                                                    {
                                                        inputField?.scaleImage.map( (image,index) => {
                                                            //console.log('image',URL.createObjectURL(image))
                                                            return(
                                                            <div 
                                                                className='flex flex-row justify-center align-center items-center'
                                                                style={{padding:'0 5px'}}
                                                            >
                                                                <Button className='flex flex-row justify-center align-center items-center' 
                                                                    onClick={(e)=>{e.stopPropagation(); 
                                                                    window.open(
                                                                    `${URL.createObjectURL(image)}`,
                                                                    '_blank'
                                                                    )}}
                                                                    
                                                                    sx={{
                                                                        borderRadius: 0,
                                                                        color: 'blue',
                                                                        padding: 0,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                >
                                                                
                                                                    <img
                                                                    style={{
                                                                        // maxWidth: '100px', // Ensure the image does not exceed the width of the button
                                                                        // maxHeight: '50px', // Ensure the image does not exceed the height of the button
                                                                        width: '50px', // Maintain aspect ratio
                                                                        height: '20px', // Maintain aspect ratio
                                                                    }}
                                                                        src={`${URL.createObjectURL(image)}`}
                                                                    />
                                                                </Button>

                                                                <div 
                                                                    className='flex justify-center align-center items-center' 
                                                                    style={{
                                                                    background: "#edca33",
                                                                    border: '1px solid black',
                                                                    height: '30px',
                                                                    width: '30px', 
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    }}
                                                                >
                                                                    <IconButton onClick={(e) => {e.stopPropagation(); handleDeleteEditScaleImage(inputField?.id,index)}}><DeleteIcon fontSize='small'/></IconButton>
                                                                </div>

                                                            </div>
                                                            )
                                                        })
                                                    }
                                                  </div>
                                                </TableCell> 
                                                : 
                                                null
                                            }


                                           
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                { idx != 0 ? <IconButton 
                                onClick={() => {handleRemoveInputField(inputField?.id)}}  
                                sx={{ '&:hover': {
                                    backgroundColor: inputField?.wait_time
                                    ? 'black'
                                    : inputField?.isSub
                                    ? '#e9c917'
                                    : 'black'},
                                    backgroundColor:inputField?.wait_time
                                    ? 'black'
                                    : inputField?.isSub
                                    ? '#e9c917'
                                    : 'black',
                                    position:'absolute',top:0,left:0,color:'white !important'}}>
                                    <Icon sx={{color:'white !important'}} size='large'>delete</Icon>
                                    </IconButton> : null}
                                    
                                    <div
                                        className="flex flex-row justify-center align-center items-center w-full"
                                        style={{
                                            position: 'sticky', // Fix the arrows relative to the viewport
                                             bottom: '0px',
                                            zIndex: 10, // Ensure it stays above other content
                                            left: 0, // Stick to the left edge of the container
                                            right: 0, // Stick to the right edge of the container
                                        }}
                                    >
                                        <IconButton  
                                          onClick={() => {
                                            const tableContainer = document.getElementById('tableContainer_'+inputField.id); // Select the table container
                                            if (tableContainer) {
                                              tableContainer.scrollTo({
                                                left: 0, // Scroll all the way to the left
                                                behavior: 'smooth', // Enable smooth scrolling
                                            });
                                            }
                                          }}
                                      >
                                        <WestIcon style={{ cursor: 'pointer', marginRight: '8px' }} sx={{background:'black',color:'#edca33',border:3,borderRadius:5,borderColor:'#edca33'}} />
                                      </IconButton>
                                        
                                        <IconButton
                                          onClick={() => {
                                            const tableContainer = document.getElementById('tableContainer_'+inputField.id); // Select the table container
                                            if (tableContainer) {
                                              tableContainer.scrollTo({
                                                left: tableContainer.scrollWidth, // Scroll all the way to the right
                                                behavior: 'smooth', // Enable smooth scrolling
                                            });
                                            }
                                          }}
                                        >
                                          <EastIcon style={{ cursor: 'pointer', marginLeft: '8px' }}  sx={{background:'black',color:'#edca33',border:3,borderRadius:5,borderColor:'#edca33'}}/>
                                        </IconButton>
                                    </div>
                            </TableContainer>
                        )})
                    }
                    
                      
                </Box>
            }
          </DialogContent>

          <DialogActions className='flex flex-col jusitfy-center align-center items-center'>
            <div
            className="flex flex-row items-center justify-center"
            >
            <IconButton 
                    onClick={handleAddInputField}
                >
                    <AddIcon sx={{ height:'30px',width:'30px', background:'black',color:'#edca33',border:3,borderRadius:5,borderColor:'#edca33'}}/>
                </IconButton>
            </div>

            <div
            className="flex flex-row items-center justify-center p-16"
            >
                <Button
                    className="cursor-pointer text-18"
                    variant='contained'
                    style={{}}
                    onClick={handleSubmit}
                    type="submit"
                >
                    {t('SUBMIT')}
                </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.loadz_auth?.AuthReducer?.user,
  };
};
const mapDispatchToProps = (dispatch) => ({
  getAllTicketJobs: (payload, onError) =>
    dispatch(JobTicketAction.getAllTicketJob(payload, onError)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateMultiTicketTable);
